(function ($) {
    $(document).ready(function () {

        // $(".search-grid .search-form-wrapper .ais-SearchBox-input").keyup(function() {
        //     var $val = $(this).val();
        //     if ($val.length > 0) {
        //         $(this).parent().find(".ais-SearchBox-reset").css({ opacity: "1" });
        //     } else {
        //         $(this).parent().find(".ais-SearchBox-reset").css({ opacity: "0" });
        //     }
        // });

    
        $(".search-grid .ais-SearchBox-input").focus(function(){
            $(this).parent().addClass("selected-state");
        }).blur(function(){
            $(this).parent().removeClass("selected-state");
            var $val = $(this).val();
            if ($val.length > 0) {
                $(".search-grid .search-form-wrapper input").css({ border: "2px solid #000000" });
            } else{
                $(".search-grid .search-form-wrapper input").css({ border: "1px solid #000000" });
            }
        });

        // $(".search-grid .search-form-wrapper .ais-SearchBox-reset").on("click", function (e) {
        //     $(".search-grid .search-form-wrapper .ais-SearchBox-input").val('');
        //     $(".search-grid .search-form-wrapper .ais-SearchBox-reset").css({ opacity: "0" });
        // });

        // $('.search-grid .search-tabs li:first-of-type ').addClass('active');
        // $('.search-grid .filter-wrapper:first-of-type ').show();
        $('.search-grid  .filter-wrapper ').hide();

        $('.search-grid .filter-wrapper').each(function () {
           if($(this).find('.side-menu').length==0) {
            $(this).addClass('full-width');
           }
        });

        $('.search-grid .search-tabs li').on('click', function () {

            $(this).addClass('active');
            $('.search-grid .search-tabs li').not(this).removeClass('active');

            var ind=$(this).index();
            $('.search-grid .filter-wrapper:eq('+ind+')').fadeIn();
            $('.search-grid .filter-wrapper').not(':eq('+ind+')').hide();

        });

        // Filter dropdown

        $('.search-grid .filter-wrapper .filter-title span').hide();
        const staticWid = $('.search-grid .filter-data').width() - 60;
        $('.search-grid .selected-data').hide();
        var LiN = $('.search-grid .filter-wrapper .wrapper .filter-dropdown').length;
        $('.search-grid .filter-wrapper .filter-items').each(function () {
            if($(this).find('li.ais-RefinementList-item--selected').length>0) {
                var text=$(this).find('li.ais-RefinementList-item--selected').text();
                $(this).parents('.filter-dropdown').find('p').text(text);
                $(this).siblings('.filter').addClass('used');
            }
        });

          //Closing dropdown by clickling anywhere

          $('.search-grid .filter-wrapper .filter-items').on("click", function (e) {
              e.stopPropagation();
            });
            $('.search-grid .filter-wrapper .filter').on('click', function (e) {
              e.stopPropagation();
              //e.preventDefault();
              if ($(this).parent().hasClass('open')) {
                var selectedItems = $(".filter-dropdown.open li.ais-RefinementList-item--selected").length;
                $(".filter-dropdown.open .filter p").html(selectedItems + " Topics Selected").css("color", "#000");
                if (selectedItems == 0) {
                  $(".filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
                }
                $(this).parent().removeClass('open');
              }
              else {
                var selectedItems = $(".filter-dropdown.open li.ais-RefinementList-item--selected").length;
                $(".filter-dropdown.open .filter p").html(selectedItems + " Topics Selected").css("color", "#000");
                if (selectedItems == 0) {
                  $(".filter-dropdown.open .filter p").html("Select from the list...").css("color", "#B9B9B9");
                }
                $(this).parent().siblings().removeClass('open');
                $(this).parent().addClass('open');
              }
            });


            //Click functionality of filter dropdowns
        $('.search-grid .filter-wrapper .filter-items li').on("click", function (e) {
            //multiple check options
            if($(this).parents('.filter-dropdown').hasClass('topic')) {

                if($(this).hasClass('ais-RefinementList-item--selected')) {
                    $(this).removeClass('ais-RefinementList-item--selected');
                    $(this).parents('.filter-items').removeClass('used');
                    var text=$(this).text();
                    $(this).parents('.filter-content').find('.filter-data span').each(function () {
                        if($(this).text()==text) {
                            $(this).remove();
                        }
                    });
                }
                else {
                    $(this).addClass('ais-RefinementList-item--selected');
                }
                if($(this).parents('.filter-items').find('.ais-RefinementList-item--selected').length>0) {
                    if($(this).hasClass('ais-RefinementList-item--selected')) {
                        var text=$(this).text();
                        // $(this).parents('.filter-dropdown').find('p').text(text);
                    }
                }
                else {
                    $(this).parents('.filter').removeClass('used');
                    $(this).parents('.filter-dropdown').find('p').text('Select from the list..');
                }

            }

            //Date and Search filers - single selection options
            if($(this).parents('.filter-dropdown').hasClass('date') || $(this).parents('.filter-dropdown').hasClass('search')) {

                if($(this).hasClass('selected')) {
                //Removing filter if already selected
                //     $(this).removeClass('selected');
                //     $(this).parents('.filter-items').removeClass('used');
                //     var selected=$(this).text();
                //     $(this).parents('.filter-content').find('.filter-data .outer-wrapper span').each(function () {
                //         var ths=$(this);
                //         if(ths.text()==selected) {
                //             ths.remove();
                //         }
                //     });
                //     //Removing date range
                //     if($(this).hasClass('date-wrapper')) {
                //         $(this).parents('.filter-content').find('.filter-data .outer-wrapper span.range').remove();
                //     }
                }
                else {
                    //Adding filter if it was not previously selected
                    var selected=$(this).siblings('.selected').text();
                    if($(this).siblings('.date-wrapper').hasClass('selected')) {
                        $(this).parents('.filter-content').find('.filter-data .outer-wrapper span.range').remove();
                        $(this).siblings('.data-wrapper').removeClass('.selected');
                    }
                    $(this).parents('.filter-content').find('.filter-data .outer-wrapper span').each(function () {
                        var ths=$(this);
                        if(ths.text()==selected) {
                            ths.remove();
                        }
                    });
                    $(this).addClass('selected');
                    $(this).siblings().removeClass('selected');

                    var text;

                    if($(this).hasClass('date-wrapper')) {
                        //date range selection
                        var startDate, endDate;
                        startDate=$(this).find('.start .selectboxit-text').text()+" "+$(this).find('.start .date input').val()+" "+$(this).find('.start .year input').val();
                        endDate=$(this).find('.end .selectboxit-text').text()+" "+$(this).find('.end .date input').val()+" "+$(this).find('.start .year input').val();
                        text=startDate+" - "+endDate;
                        //appending date range
                        $(this).parents('.filter-content').find('.filter-data .outer-wrapper').append('<span class="range">'+text+'</span>');   
                    }
                    else {
                         text = $(this).text();
                        //appending filter values (not date range)
                        $(this).parents('.filter-content').find('.filter-data .outer-wrapper').append('<span>'+text+'</span>');
                    }
                    var len=$(this).parents('.filter-content').find('.filter-data .outer-wrapper').find('span').length;

                    $(this).parents('.filter-wrapper').find('.selected-data').show();   
                }
            }

            //Fellows filter overlay
            if($(this).parents('.filter-dropdown').hasClass('search')) {
                if($(this).parents('.filter-wrapper').find('.selected-data span.fellow-all').length>0) {
                    var fellowTag=$(this).parents('.filter-wrapper').find('.selected-data span.fellow-all').text();
                    $(this).parents('.filter-wrapper').find('.selected-data span.fellow-all').remove();
                    if($(this).parents('.filter-wrapper').find('.filter-overlay li.selected').text()==fellowTag) {
                        $(this).parents('.filter-wrapper').find('.filter-overlay li').removeClass('selected');
                    }
                }
            }

            if($(this).parents('.wrapper').siblings('.selected-data').find('.outer-wrapper span').length==0) {
                $(this).parents('.wrapper').siblings('.selected-data').hide();
            }
        });

        //Alphabetical-filter

        var $list = $(".search-grid .filter-wrapper .filter-content .wrapper .filter-dropdown .filter-items .alphabetical-list");

        $list.children().detach().sort(function(a, b) {
          return $(a).text().localeCompare($(b).text());
        }).appendTo($list);

        //multi-select dropdowns
        $('.search-grid .filter-wrapper .filter-dropdown.topic li').click(function () {
            if($(this).hasClass('ais-RefinementList-item--selected')) {
                var text = $(this).text();

                $(this).parents('.filter-content').find('.filter-data .outer-wrapper').append('<span>'+text+'</span>');
                var len=$(this).parents('.filter-content').find('.filter-data .outer-wrapper').find('span').length;

                $(this).parents('.filter-wrapper').find('.selected-data').show();

            }
        });


        //Clear all functionality
        $('.search-grid .selected-data .filter-title span').click(function () {
            $(this).parents('.filter-wrapper').find('.filter-dropdown li').removeClass('ais-RefinementList-item--selected');
            $(this).parents('.selected-data').find('.outer-wrapper').empty();
            $(this).parents('.selected-data').hide();
            $(this).parents('.filter-wrapper').find('.filter-overlay li.selected').removeClass('selected');
            $(this).parents('.filter-wrapper').find(".filter p").html("Select from the list...").css("color", "#B9B9B9");
        });

        //Dropdown Show all functionality
        $('.search-grid .search .btn-wrapper a.show').click(function (e) {
            e.preventDefault();
            $(this).parents('.filter-items').siblings('.filter-overlay').fadeIn();
            $(this).parents('.filter-items').siblings('.filter-overlay').find('.content-wrapper').fadeIn();
        });

        //Dropdown Clear functionality
        $('.search-grid .btn-wrapper a.clear').click(function (e) {
            e.preventDefault();

            //clearing date-range
            if($(this).parents('.filter-dropdown').hasClass('date') && $(this).parents('.filter-items').find('li.selected').hasClass('date-wrapper')) {
                $(this).parents('.filter-items').find('li.selected.date-wrapper').removeClass('selected');
                $(this).parents('.wrapper').siblings('.selected-data').find('span.range').remove();
            }
            $(this).parents('.filter-items').find('li.ais-RefinementList-item--selected').each(function () {
                var li=$(this);
                var text=li.text();
                $(this).parents('.wrapper').siblings('.selected-data').find('span').each(function () {
                    var ths=$(this);
                    if(ths.text()==text) {
                        ths.remove();
                        li.removeClass('ais-RefinementList-item--selected');
                    }

                });

                $(this).parents(".filter-dropdown").find(".filter p").html("Select from the list...").css("color", "#B9B9B9");

            });

            //clearing fellow filter
            $(this).parents('.filter-wrapper').find('.fellows-wrapper li.ais-RefinementList-item--selected').removeClass('ais-RefinementList-item--selected');

            if($(this).parents('.wrapper').siblings('.selected-data').find('.outer-wrapper span').length==0) {
                $(this).parents('.wrapper').siblings('.selected-data').hide();
            }

        });

              
        //Clearing filter on click of filter tags
        $(document).on('click','.search-grid .filter-data .outer-wrapper span',function () {
           var text=$(this).text() ;
           var li=$(this).parents('.filter-wrapper').find('.filter-dropdown li');
            li.each(function () {
                if($(this).text()==text) {
                    $(this).removeClass('ais-RefinementList-item--selected');
                    var len=$(this).parents('.filter-dropdown').find('li.ais-RefinementList-item--selected').length;
                    if(len==0) {
                        $(this).parents(".filter-dropdown").find(".filter p").html("Select from the list...").css("color", "#B9B9B9");
                    }
                    else {
                        $(this).parents(".filter-dropdown").find(".filter p").html(len+" Topics Selected").css("color", "#000");
                    }
                }
            });

            var parent=$(this).parents('.filter-data');

            if($(this).hasClass('range')) {
                $(this).parents('.filter-wrapper').find('.filter-dropdown li.date-wrapper').removeClass('selected');
            }

            $(this).remove();

            if(parent.find('span').length==0) {
                parent.parents('.selected-data').hide();
            }

        });

        $(document).click(function (e) {
            //closing dropdowns
            var target=$(e.target).closest('.search-grid .filter-wrapper');
           if(!target.is(".search-grid .filter-dropdown")) {
               $(".search-grid .filter-dropdown").removeClass('open');
           }
            //closing overlay
        //    var targetOverlay=$(e.target).closest('.search-grid .filter-overlay .content-wrapper');
        //    if(!targetOverlay.is(".search-grid .filter-overlay .content-wrapper")) {
        //         $('.search-grid .filter-overlay').fadeOut();
        //    }
            // if(targetOverlay.find('.fellows-wrapper li.selected').length>0) {
            //     var tag=targetOverlay.find('.fellows-wrapper li.selected').text();
            //     var i=targetOverlay.find('.fellows-wrapper li.selected').attr('index');
            //     targetOverlay.parents('.filter-wrapper').find('.selected-data .outer-wrapper').append('<span class="fellow-all" index='+i+'>'+tag+'</span>');
            //     targetOverlay.parents('.filter-wrapper').find('.selected-data').show();
            // }

        })

        if ($('.search-grid .filter-wrapper .filter-dropdown.date .date-wrap .date-range select').length > 0) {
          $(".search-grid .filter-wrapper .filter-dropdown.date .date-wrap .date-range select").selectBoxIt({
              showEffect: "fadeIn",
              showEffectSpeed: 200,
              hideEffect: "fadeOut",
              hideEffectSpeed: 200
          });
      }
      
      $('.search-grid .result--wrapper .result-filter ul li:first-of-type').addClass('selected');

      $('.search-grid .result--wrapper .result-filter ul li').click(function () {
        $(this).addClass('selected');
        $(this).siblings().removeClass('selected');
    });  

      $('.search-grid .filter-overlay .close-btn').click(function () {
            $(".search-grid .filter-overlay").fadeOut();
      });

        $('.search-grid .filter-overlay .fellows-wrapper li').click(function () {
            $(this).addClass('selected');
            $(this).siblings().removeClass('selected');

            //fellows filter
            if($(this).parents('.filter-overlay').find('li').hasClass('selected')) {
                var text=$(this).parents('.filter-wrapper').find('.search .filter-items li.selected').text();
                $(this).parents('.filter-wrapper').find('.search .filter-items li.selected').removeClass('selected');
                $(this).parents('.filter-wrapper').find('.selected-data span.fellow-all').remove();
                $(this).parents('.filter-wrapper').find('.selected-data span').each(function () {
                    if($(this).text()==text) {
                        $(this).remove();
                    }
                });
            }
        });

        //overlay alphabet filter scroll
        $('.search-grid .filter-overlay .fellows-wrapper li').each(function () {
            var startAlpha = $(this).text().substring(0, 1);
            $(this).addClass(startAlpha);
        });
        $('.search-grid .filter-overlay .col-wrap li').each(function (i) {
            var id=$(this).text();
            $(this).parents().find('.fellows-wrapper li[class="'+id+'"]').first().attr('id',id);
        });

        //overlay alphabet filter scroll
        $('.search-grid .filter-overlay .col-wrap li').click(function () {
            $(this).addClass('selected');
            $(this).siblings().removeClass('selected');
            var alpha=$(this).text();

        });

        $('.search-grid .tab-wrap').first().addClass('active');
        $('.search-grid .mobile-tabs').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            // $('.search-grid .tab-wrap').toggleClass('active');
            $(this).parent(".tab-wrap").toggleClass('active');
        });

        // $(document).on("click", function () {
        //     $(".search-grid .tab-wrap").removeClass("active");
        // });

        $(".search-grid .search-tabs li a").on("click", function (e) {
            // e.preventDefault();
            $(".search-grid .search-tabs li").removeClass("active");
            $(this).parent().addClass("active");
            $('.search-grid .tab-wrap').removeClass('active');
            $(".search-grid .mobile-tabs p").empty();
            $(this).clone().appendTo(".mobile-tabs p");

        //    go to url if there are no #

            const url = window.location.pathname;
            const Href = $(this).attr("href");
            if ((url.indexOf('/Href/') >= 0) && (Href.indexOf('#') == -1)) {
                window.location.href = Href;
                location.reload(true);
            }

        }); 

        $(':input[type="number"]').on('input', function() {
            if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);
    
    });

        $('input[type="number"]').on('keyup',function(){
            v = parseInt($(this).val());
            min = parseInt($(this).attr('min'));
            max = parseInt($(this).attr('max'));
    
            /*if (v < min){
                $(this).val(min);
            } else */if (v > max){
                $(this).val(max);
            }
        });

        


        $('.ais-Pagination--noRefinement').parent().fadeOut();

        // $('.search-grid .full-width .eight-col img[src=""]').css({ filter: "grayscale(0)" });

    })
  })
  (jQuery);